import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import LeaveGroup from 'modules/posts/components/Groups/Leave'

const LeaveGroupPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <LeaveGroup onClose={() => navigate(navigation.dashboard.fullPath())} groupId={Number(id)} />
  )
}

export default LeaveGroupPage
